import { ENUMS } from 'services/consts';

import AdvanceSettings from '../AdvanceSettings';
import DeveloperSettings from '../DeveloperSettings';
import SalesChannelDetailsForm from '../Forms/SalesChannelDetailsForm';

const Ticimax = () => (
	<>
		<SalesChannelDetailsForm showCredentials={false} showSecret={false} />
		<AdvanceSettings
			fields={['addHour', 'codString', 'commentKeys', 'TrackingUrlType', 'statuses']}
			enumName={ENUMS.DEFAULT_CREDENTIALS_STATUSES}
		/>

		{/* developer */}
		<DeveloperSettings
			fields={[
				'secret',
				'apiUrl',
				'productUrl',
				'ignoreNonCodOnPending',
				'paymentNeedConfirm',
				'webhookStatus',
				'lastUpdateDate',
				'productUpdateDate'
			]}
		/>
	</>
);

export default Ticimax;
